import { h, Component } from "preact";

import style from "./style";
import { Text } from "preact-i18n";

class BackButton extends Component {
  handleGoBack() {
    window.history.back();
  }
  render() {
    return (
      <button class={style["back-button"]} onclick={this.handleGoBack}>
        <Text id="components.Terug naar vorige pagina">
          Terug naar vorige pagina
        </Text>
      </button>
    );
  }
}

export default BackButton;
